import './_navigation';
import './_forms';
import './_share';

(() => {
    document.querySelectorAll('[data-placeholder-hover]').forEach((el) => {
        const placeholder = el.getAttribute('placeholder');
        const hover = el.getAttribute('data-placeholder-hover');

        el.addEventListener('mouseenter', () => {
            el.setAttribute('placeholder', hover);
        });

        el.addEventListener('mouseleave', () => {
            el.setAttribute('placeholder', placeholder);
        });
    });
})();

import './_handorgel';
import './_news'; // Must be after _forms!
import './_events'; // Must be after _forms!


import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

window.Stimulus = Application.start()
window.Stimulus.debug = process.env.NODE_ENV === 'development'

const context = require.context("../controllers", true, /\.js$/)
window.Stimulus.load(definitionsFromContext(context))
